<section class="content">
  <div class="container-fluid">
    <form [formGroup]="filterForm">
      <div class="row">
        <!-- <ng-container *ngIf="childProp.title !== 'DOWNLOAD_BULK_INVOICE'"> -->
        <div class="col-md-4">
          <div class="form-group">
            <label for="dateType">Date based on </label>

            <ng-select
              id="dateType"
              name="dateType"
              [ngClass]="{
                  'is-invalid':
                    (filterForm.get('dateType')?.hasError('required') &&
                      filterForm.get('dateType')?.touched) ||
                    (filterForm.get('dateType')?.hasError('pattern') &&
                      filterForm.get('dateType')?.touched)
                }"
              formControlName="dateType"
              [items]="dateOptions"
              [multiple]="false"
              [closeOnSelect]="true"
              [bindLabel]="'name'"
              [searchable]="true"
              placeholder="Enter credit type">
            </ng-select>

            <span class="error invalid-feedback"
              >Please select credit type</span
            >
          </div>
        </div>
        <!-- </ng-container> -->

        <div class="col-md-4">
          <div class="form-group">
            <label for="fromDate"
              >From Date <span class="text-danger">*</span>
            </label>
            <input
              [owlDateTime]="dt2"
              [owlDateTimeTrigger]="dt2"
              class="form-control"
              formControlName="fromDate"
              placeholder="Enter From Date"
              [ngClass]="{
                'is-invalid':
                  (filterForm.get('fromDate')?.invalid &&
                    filterForm.get('fromDate')?.touched) ||
                  filterForm.hasError('invalidDateRange')
              }" />
            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
            <!-- Error message for 'required' validation -->
            <span
              class="error invalid-feedback"
              *ngIf="filterForm.get('fromDate')?.errors?.['required'] && filterForm.get('fromDate')?.touched">
              Please select a from date
            </span>
            <!-- Error message for 'invalidDateRange' validation -->
            <span
              class="error invalid-feedback"
              *ngIf="filterForm.hasError('invalidDateRange') && !filterForm.get('fromDate')?.errors?.['required'] ">
              Date range should not exceed three months.
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="toDate"
              >To Date <span class="text-danger">*</span></label
            >
            <input
              [max]="maxDate"
              [owlDateTime]="dt1"
              [owlDateTimeTrigger]="dt1"
              class="form-control"
              formControlName="toDate"
              placeholder="Enter To Date"
              [ngClass]="{
                'is-invalid':
                  (filterForm.get('toDate')?.invalid &&
                    filterForm.get('toDate')?.touched) ||
                  filterForm.hasError('invalidDateRange')
              }" />
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>

            <!-- Error message for 'required' validation -->
            <span
              class="error invalid-feedback"
              *ngIf="filterForm.get('toDate')?.errors?.['required'] && filterForm.get('toDate')?.touched">
              Please select to date
            </span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="clientId">Client </label>
            <ng-select
              [loading]="clientLoading"
              id="clientId"
              (clear)="clearSearchClients()"
              (input)="onInput($event)"
              (blur)="onFocus(false, 'clientId')"
              (focus)="onFocus(true, 'clientId')"
              [searchFn]="customSearchFn"
              name="clientId"
              [closeOnSelect]="true"
              [ngClass]="{
                'is-invalid':
                  filterForm.get('clientId')?.hasError('required') &&
                  filterForm.get('clientId')?.touched
              }"
              formControlName="clientId"
              [items]="clientOptions"
              [multiple]="false"
              [searchable]="true"
              [closeOnSelect]="true"
              [bindLabel]="'name'"
              [searchable]="true"
              placeholder="Select Client">
              <ng-template ng-label-tmp let-item="item">
                <div>
                  <ng-container *ngIf="item.name">
                    <span class="rectangle-tag bg-success mr-2"
                      >{{ item.name }}</span
                    >
                  </ng-container>
                  <ng-container *ngIf="item.id">
                    <span class="rectangle-tag bg-info mr-2"
                      >{{ item.id }}</span
                    >
                  </ng-container>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>
                  <ng-container *ngIf="item?.name">
                    <span class="rectangle-tag bg-success mr-2"
                      >{{ item.name }}</span
                    >
                  </ng-container>
                  <ng-container *ngIf="item?.id">
                    <span class="rectangle-tag bg-info">{{ item.id }}</span>
                  </ng-container>
                </div>
              </ng-template>
            </ng-select>
            <span class="error invalid-feedback">Please select a client</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="businessType">Business Type </label>

            <ng-select
              id="businessType"
              name="businessType"
              [ngClass]="{
                'is-invalid':
                  (filterForm.get('businessType')?.hasError('required') &&
                    filterForm.get('businessType')?.touched) ||
                  (filterForm.get('businessType')?.hasError('pattern') &&
                    filterForm.get('businessType')?.touched)
              }"
              formControlName="businessType"
              [items]="businessTypesOptions"
              [multiple]="true"
              [closeOnSelect]="true"
              [bindLabel]="'name'"
              [searchable]="true"
              (change)="onBusinessTypeChange($event)"
              placeholder="Enter business type">
            </ng-select>

            <span class="error invalid-feedback"
              >Please select business type</span
            >
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="businessType">Invoice Type </label>

            <ng-select
              id="businessType"
              name="businessType"
              [ngClass]="{
                'is-invalid':
                  (filterForm.get('invoiceType')?.hasError('required') &&
                    filterForm.get('invoiceType')?.touched) ||
                  (filterForm.get('invoiceType')?.hasError('pattern') &&
                    filterForm.get('invoiceType')?.touched)
              }"
              formControlName="invoiceType"
              [items]="invoiceTypes"
              [multiple]="false"
              [closeOnSelect]="true"
              [bindLabel]="'name'"
              [searchable]="true"
              placeholder="Enter invoice type">
            </ng-select>

            <span class="error invalid-feedback"
              >Please select invoice type</span
            >
          </div>
        </div>
        <div class="col-md-12 mb-4">
          <div class="row">
            <div class="col-md-12">
              <div class="card-footer-display">
                <button
                  class="btn btn-secondary float-right"
                  (click)="onClear()"
                  type="button">
                  Reset
                </button>

                <button
                  (click)="onSubmit()"
                  [disabled]="filterForm.invalid"
                  class="btn btn-primary float-right">
                  <ng-container *ngIf="loaderVariable; else submitText">
                    <span
                      class="spinner-border spinner-border-sm mr-1"
                      role="status"
                      aria-hidden="true"></span>
                    {{ childProp.buttonText }}
                  </ng-container>
                </button>
                <ng-template #submitText>
                  <i class="fas fa-download"></i> {{ childProp.buttonText }}
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
